import { createSelector } from 'reselect';
import columns from '../../../../../react-table/helpers/columns';
import { weekColumns } from '../../component/EpgLinkByLinkMetadataMapper';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal, totalRowRatio } from "../../../../../react-table/helpers/rowTotals";

export const getData = ReportDefinitions.EPG_LINK_BY_LINK_REPORT_013.getDataFunction();
const getMetadata = state => state.reporting.EPG_LINK_BY_LINK_REPORT_013.metadata;
export const getIsLoading = state => state.reporting.EPG_LINK_BY_LINK_REPORT_013.isLoading;
export const getGeneratedOnDateTime = state => getMetadata(state) && getMetadata(state).generatedOnDateTime;

export function determineClassName(value) {
  let className = '';

  if (value >= 97.0 && value <= 100.0) {
    className = 'bg-through-dark-green';
  }
  if (value >= 95.0 && value <= 96.9) {
    className = 'bg-through-dark-yellow';
  }

  if (value <= 94.9) {
    className = 'bg-through-dark-red';
  }
  return className;
}

export function getGetPropsForWeek() {
  return ((state, rowInfo) => {
    let className = '';
    if (rowInfo) {
      const responded = (rowInfo.row['total.pct']);
      className = determineClassName(responded);
    }
    return {
      className,
    };
  });
}

export const getColumns = createSelector(getMetadata, getData, (metadata, data) => {
  if (!metadata || !metadata.columns) {
    return [];
  }
  const { TextColumn, NonZeroNumberColumn, PercentageColumn } = columns(data);

  return [
    {
      Header: 'Operator',
      columns: [
        new TextColumn('Origin', 'operator.origin'),
        new TextColumn('Destination', 'operator.destination'),
      ],
    },
    {
      Header: 'IMPC',
      columns: [
        new TextColumn('Origin', 'impc.origin'),
        new TextColumn('Destination', 'impc.destination')
          .withTotalHeader('Total'),
      ],
    }, ...weekColumns(metadata.columns.slice(7), data),
    {
      Header: 'Total',
      columns: [
        new NonZeroNumberColumn('PREDES', 'total.predes')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('RESDES', 'total.resdes').withTotalHeader(sumTotal),
        new PercentageColumn('%', 'total.pct').withTotalHeader(totalRowRatio(['total.resdes', 'total.predes'])).withGetProps(getGetPropsForWeek()),
      ],
    },
  ];
});
